import { FC } from 'react';
import { PreloadedQuery, usePreloadedQuery } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import Page from 'components/Page';
import PagesList from 'components/PagesList';

import { withData } from 'lib';
import { ContentPageListPageQuery } from '__generated__/ContentPageListPageQuery.graphql';

const query = graphql`
  query ContentPageListPageQuery {
    ...PagesList_data
  }
`;

type Props = {
  preloadedQuery: PreloadedQuery<ContentPageListPageQuery>;
};

const ContentPageListPage: FC<Props> = ({ preloadedQuery }) => {
  const data = usePreloadedQuery<ContentPageListPageQuery>(
    query,
    preloadedQuery
  );

  return (
    <Page
      breadcrumbs={[
        { link: '/content', name: 'Turinys' },
        { name: 'Puslapiai' },
      ]}>
      <PagesList data={data} />
    </Page>
  );
};

export default withData<ContentPageListPageQuery>({
  query,
})(ContentPageListPage);
